// extracted by mini-css-extract-plugin
module.exports = {"navigation-header-wrapper":"Header_navigation-header-wrapper__U1PUb","navigation-header":"Header_navigation-header__eSSu9"};